// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"0190c0d7","155":"1cc45f9c","531":"ec45e435","635":"1abb9e79","787":"157bd1c4","973":"19f69809"}[chunkId] + ".chunk.js";
};